import { useContext, useState, useEffect } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import * as Yup from 'yup';
import { Formik, ErrorMessage, Form } from "formik";
import FormError from "../../common/FormError";

export const FormPago = () => {
    const { pagos } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(pagos.editPago);

    useEffect(() => {
        setInitialvalues(pagos.editPago);
    }, [pagos.editPago]);

    const validateSchema = Yup.object({
        codigo: Yup.string()
            .max(50, 'El texto debe tener al menos 3 letras.')
            .nullable(),
        fecha: Yup.date()
            .required('El campo es obligario.'),
        monto: Yup.number()
            .required('El campo es obligario.')
            .min(0, 'El número debe ser mayor a 0'),
        descripcion: Yup.string()
            .min(3, 'El texto debe tener al menos 3 letras.')
            .max(200, 'El texto es demasiado largo')
            .required('El campo es obligario.'),
        notificacion: Yup.string()
            .max(200, 'El texto es demasiado largo')
            .nullable(),
        estado: Yup.string()
            .required('El campo es obligario.'),
    });

    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={pagos.handle_save_pago}
                validationSchema={validateSchema}
                enableReinitialize={true}
            >
                {
                    (formik) => (
                        <Form>
                            <fieldset disabled={pagos.loadingPago}>
                                <div className="row">
                                    <div className="col mb-2">
                                        <label className="form-label">
                                            Código
                                        </label>
                                        <input type="text" className="form-control form-control-sm"
                                            value={formik.values.codigo}   
                                            onChange={(e) => formik.setFieldValue('codigo', e.target.value)}
                                        />
                                        <ErrorMessage name="codigo" component={FormError} />
                                    </div>
                                    <div className="col mb-2">
                                        <label className="form-label">
                                            Fecha
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input type="date" className="form-control form-control-sm"
                                            value={formik.values.fecha}   
                                            onChange={(e) => formik.setFieldValue('fecha', e.target.value)}
                                        />
                                        <ErrorMessage name="fecha" component={FormError} />
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">
                                        Monto en Bs.
                                        <span className="text-danger">(*)</span>
                                    </label>
                                    <input type="number" step="0.01" className="form-control form-control-sm"
                                        value={formik.values.monto}   
                                        onChange={(e) => formik.setFieldValue('monto', e.target.value)}
                                    />
                                    <ErrorMessage name="monto" component={FormError} />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">
                                        Descripción
                                        <span className="text-danger">(*)</span>
                                    </label>
                                    <input type="text" className="form-control form-control-sm"
                                        value={formik.values.descripcion}   
                                        onChange={(e) => formik.setFieldValue('descripcion', e.target.value)}
                                    />
                                    <ErrorMessage name="descripcion" component={FormError} />
                                </div>
                                {/* <div className="mb-2">
                                    <label className="form-label">Notificación</label>
                                    <input type="text" className="form-control form-control-sm"
                                        value={formik.values.notificacion ?? ""}
                                        onChange={(e) => formik.setFieldValue('notificacion', e.target.value)}
                                    />
                                    <ErrorMessage name="notificacion" component={FormError} />
                                </div> */}

                                <div className="mb-2">
                                    <label className="form-label">Estado</label>
                                    <select name="estado" id="estado" className="form-select form-select-sm"
                                        value={formik.values.estado}
                                        onChange={(e) => formik.setFieldValue('estado', e.target.value)}
                                    >
                                        <option value="PENDIENTE">PENDIENTE</option>
                                        <option value="PAGADO">PAGADO</option>

                                    </select>
                                    <ErrorMessage name="estado" component={FormError} />
                                </div>

                                <div className="mb-2 d-flex justify-content-between">
                                    <div>
                                        <span className="text-danger">(*) </span>
                                        <u>Campo obligatorio.</u>
                                    </div>
                                    <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                        {
                                            (pagos.loadingPago)? "Guardando..." : "Guardar"
                                        }
                                    </button>
                                </div>
                            </fieldset>
                        </Form>
                    )
                }
            </Formik>
        </div>
    );
}